export default __webpack_public_path__ + "static/media/quantispacer_img.2eec9dc8.png";